const style = {
  privacyAndTermsOfUseLink: {
    color: '#4A4F54',
    textDecoration: 'underline',
    fontWeight: 600
  }
};

export default style;
